// directives/img.js
function createLoadingMask(el) {
  const mask = document.createElement("div");
  mask.className = "img-loading-mask";
  mask.innerText = "图片加载中...";
  mask.style.display = "none";
  const parent = el.parentNode;
  if (parent && getComputedStyle(parent).position === "static") {
    parent.style.position = "relative";
  }
  parent.appendChild(mask);
  return mask;
}

function resolveOptions(binding) {
  return typeof binding.value === "string"
    ? { src: binding.value }
    : binding.value || {};
}

function loadImage(el, options) {
  const { src, default: defaultImg } = options;

  el._imgVersion = (el._imgVersion || 0) + 1;
  const version = el._imgVersion;
  let is_loading = false;
  // 创建或复用 loading 遮罩

  if (!src) return;

  const img = new Image();
  img.src = src;

  img.onload = () => {
    if (el._imgVersion === version) {
      el.src = src;
      if (el._loadingMask && el._loadingMask.style) {
        el._loadingMask.style.display = "none";
      }

      is_loading = true;
    }
  };

  img.onerror = () => {
    if (el._imgVersion === version) {
      if (defaultImg) el.src = defaultImg;
      el._loadingMask.style.display = "none";
    }
  };

  let timer = setTimeout(() => {
    clearTimeout(timer);
    if (is_loading) return;
    if (!el._loadingMask) {
      el._loadingMask = createLoadingMask(el);
    }

    // 显示加载盒子
    el._loadingMask.style.display = "flex";
  }, 200);
}

export default {
  inserted(el, binding) {
    loadImage(el, resolveOptions(binding));
  },

  update(el, binding) {
    const newSrc =
      typeof binding.value === "string" ? binding.value : binding.value?.src;

    const oldSrc =
      typeof binding.oldValue === "string"
        ? binding.oldValue
        : binding.oldValue?.src;

    if (newSrc !== oldSrc) {
      loadImage(el, resolveOptions(binding));
    }
  },

  unbind(el) {
    el._loadingMask && el._loadingMask.remove();
    delete el._loadingMask;
    delete el._imgVersion;
  },
};
